import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';
import mergeOptions from 'styleguide/lib/merge-options';
import { pdpAddToBag } from './add-to-bag-function';

export const PLUGIN_NAME = 'addToBag';

const DEFAULTS = {};

const setEventListeners = ($el, opts) => {
    $el.on('click', function() {
        pdpAddToBag($(this), opts);
    });
}

export default function addToBag(el, options) {
    const $el = $(el);
    const opts = mergeOptions(DEFAULTS, options, $el);
    setEventListeners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, addToBag);



// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/add-to-bag.js